export default "__VITE_ASSET__dqJscWil__"